<template>
  <div class="edit-company--container">
    <div class="edit-company--form">
      <form @submit.prevent="updateCompany">
        <div class="edit-company--avatar">
          <div class="company--avatar-img">
            <img :src="croppieData.image" />
          </div>
          <div class="input-block">
            <label class="btn btn-sm btn-info" for="edit--staff-avatar"
              >Изменить изображение...</label
            >
            <input id="edit--staff-avatar" type="file" @change="changePhoto" />
          </div>
        </div>
        <div class="input-block">
          <label for="name"
            >Название вашей компании <span class="req">*</span></label
          >
          <input
            type="text"
            @focus="company.name.error = ''"
            @blur="vName"
            v-model="company.name.model"
            id="name"
          />
          <div class="form-error">{{ company.name.error }}</div>
        </div>
        <div class="input-block">
          <label for="city">Город <span class="req">*</span></label>
          <input
            type="text"
            @focus="company.city.error = ''"
            @blur="vCity"
            v-model="company.city.model"
            id="city"
          />
          <div class="form-error">{{ company.city.error }}</div>
        </div>
        <div class="input-block">
          <label for="lattitude">
            Широта (необязательное поле)

            <hints :type="'text'" :title="'Узнать координаты компании'">
              <div slot="text">
                <p>Рассмотрим получения координат на примере сервиса Яндекс.Карты</p>
                <p>
                  Найдите место, координаты которого вам необходимо получить. Кликните правой кнопкой мыши.
                  Откроется контекстное меню, где вам необходимо нажать на "Что здесь?"
                </p>
                <div class="text-center">
                  <img style="width:85%;" src="../../../assets/img/map/instruction_1.png">
                </div>
                <p>Далее, слева откроется панель с координатами</p>
                <div class="text-center">
                  <img style="width:85%;" src="../../../assets/img/map/instruction_2.png">
                </div>
                <p>Просто вставьте данные координаты в поля. Первое число - это широта, второе - долгота.</p>
                <p>
                  Если у компании есть координаты, клиент увидит иконку перехода к картам, рядом с адресом
                  на странице записи онлайн.
                </p>
              </div>
            </hints>
          </label>
          <input
            type="text"
            @focus="company.lattitude.error = ''"
            @blur="vLattitude"
            v-model="company.lattitude.model"
            id="lattitude"
          />
          <div class="form-error">{{ company.lattitude.error }}</div>
          <div class="hint">
            Параметр указывается для отображения вашей компании на карте.
            Нажмите на "?" для получения справочной информации
          </div>
        </div>
        <div class="input-block">
          <label for="longtitude">
            Долгота (необязательное поле)

            <hints :type="'text'" :title="'Узнать координаты компании'">
              <div slot="text">
                <p>Рассмотрим получения координат на примере сервиса Яндекс.Карты</p>
                <p>
                  Найдите место, координаты которого вам необходимо получить. Кликните правой кнопкой мыши.
                  Откроется контекстное меню, где вам необходимо нажать на "Что здесь?"
                </p>
                <div class="text-center">
                  <img style="width:85%;" src="../../../assets/img/map/instruction_1.png">
                </div>
                <p>Далее, слева откроется панель с координатами</p>
                <div class="text-center">
                  <img style="width:85%;" src="../../../assets/img/map/instruction_2.png">
                </div>
                <p>Просто вставьте данные координаты в поля. Первое число - это широта, второе - долгота.</p>
                <p>
                  Если у компании есть координаты, клиент увидит иконку перехода к картам, рядом с адресом
                  на странице записи онлайн.
                </p>
              </div>
            </hints>
          </label>
          <input
            type="text"
            @focus="company.longtitude.error = ''"
            @blur="vLongtitude"
            v-model="company.longtitude.model"
            id="longtitude"
          />
          <div class="form-error">{{ company.longtitude.error }}</div>
          <div class="hint">
            Параметр указывается для отображения вашей компании на карте.
            Нажмите на "?" для получения справочной информации
          </div>
        </div>
        <div class="input-block">
          <label for="address">Адрес <span class="req">*</span></label>
          <input
            type="text"
            @focus="company.address.error = ''"
            @blur="vAddress"
            v-model="company.address.model"
            id="address"
          />
          <div class="form-error">{{ company.address.error }}</div>
        </div>
        <div class="input-block mb-0">
          <label>Номер телефона <span class="req">*</span></label>
          <phone-number
              v-model="company.number.model"
              :request-validate="requestValidateNumber"
              @mask="setPhoneMask"
          ></phone-number>
        </div>

        <div class="input-block">
          <label for="company_status">
            Статус работы компании <span class="req">* </span>
            <hints :type="'text'" :title="'Что такое статус работы компании?'">
              <div slot="text">
                <p>Компания имеет 3 состояния:</p>
                <p>
                  1. <b>Работает</b> - статус в котором клиентам доступна ваша компания по ссылке и
                  они могут самостоятельно произвести запись
                </p>
                <p>
                  2. <b>Временно закрыта</b> - статус в котором клиенты могут попасть на страницу записи,
                  но не могут записаться и видят ваш текст с причиной закрытия, в котором можно написать
                  почему закрыто, до какого числа закрыто и т.д...<br>
                  При этом, если у вас несколько компаний, то на общей странице записи временно закрытая
                  компания будет отображаться так же с объявлением
                </p>
                <p>
                  3. <b>Полностью скрыть</b> - клиенты, обратившись по ссылке записи видят текст, что такой
                  компании не существует.
                  При этом, вы можете продолжать с ней работать в личном кабинете.
                </p>
              </div>
            </hints>
          </label>
          <select id="company_status" v-model="company.company_status.model">
            <option value="0">Работает</option>
            <option value="1">Временно закрыта</option>
            <option value="2">Полностью скрыть от клиентов</option>
          </select>
        </div>

        <div v-show="+company.company_status.model === 1" class="input-block">
          <label for="company_status">Описание причины закрытия</label>
          <textarea
              rows="6"
              v-model="company.closed_description.model"
              @focus="company.closed_description.error = ''"
              @blur="vClosedDescription"
          ></textarea>
          <div class="form-error">{{ company.closed_description.error }}</div>
        </div>

        <div class="input-block">
          <label for="ok_message"
            >Сообщение для клиента на e-mail <span class="req">*</span></label>
          <wysiwyg
            type="text"
            @focus="company.ok_message.error = ''"
            @blur="vOkMessage"
            rows="6"
            v-model="company.ok_message.model"
            id="ok_message"
            placeholder="Введите текст..."
          ></wysiwyg>
          <div class="form-error">{{ company.ok_message.error }}</div>
        </div>
        <div class="input-block">
          <button type="submit" class="btn btn-sm btn-success">
            Сохранить
          </button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import Validator from "../../libraries/Validator";
import PhoneNumber from "../../PhoneNumber";
import Hints from "../../Hints.vue";
import userRepository from "../../../repositories/user";

const validator = new Validator();

export default {
  name: "EditCompany",
  components: { PhoneNumber, Hints },
  data() {
    return {
      requestValidateNumber: 0,

      company: {
        name: { model: "", error: "" },
        city: { model: "", error: "" },
        lattitude: { model: "", error: "" },
        longtitude: { model: "", error: "" },
        address: { model: "", error: "" },
        number: { model: "", error: "" },
        ok_message: { model: "", error: "" },
        company_status: { model: "", error: "" },
        closed_description: { model: "", error: "" }
      },
      phoneMask: ''
    };
  },
  props: {
    data: Object,
    croppieData: Object
  },
  watch: {
    data: function(val) {
      this.company.name.model = val.company.name;
      this.company.city.model = val.company.city;
      this.company.lattitude.model = val.company.lattitude;
      this.company.longtitude.model = val.company.longtitude;
      this.company.address.model = val.company.address;
      this.company.number.model = val.company.number;
      this.company.ok_message.model = val.company.ok_message;
      this.company.company_status.model = val.company.company_status;
      this.company.closed_description.model = val.company.closed_description?val.company.closed_description:"";
    }
  },
  computed: {
    validateData() {
      let errorCount = 0;
      this.vName().result == "error" ? errorCount++ : "";
      this.vCity().result == "error" ? errorCount++ : "";
      this.vAddress().result == "error" ? errorCount++ : "";
      this.vNumber().result == "error" ? errorCount++ : "";
      this.vOkMessage().result == "error" ? errorCount++ : "";
      this.vLattitude().result == "error" ? errorCount++ : "";
      this.vLongtitude().result == "error" ? errorCount++ : "";
      this.vClosedDescription().result == "error" ? errorCount++ : "";

      return errorCount;
    }
  },
  methods: {
    setPhoneMask(val){
      this.phoneMask = val;
    },
    vName() {
      let validate = validator.validate([
        {
          fieldName: "Название компании",
          value: this.company.name.model,
          type: "required",
          length: 255
        }
      ]);
      validate.result == "error"
        ? (this.company.name.error = validate.message)
        : (this.company.name.error = "");
      return validate;
    },
    vCity() {
      let validate = validator.validate([
        {
          fieldName: "Город",
          value: this.company.city.model,
          type: "required",
          length: 45
        }
      ]);
      validate.result == "error"
        ? (this.company.city.error = validate.message)
        : (this.company.city.error = "");
      return validate;
    },
    vLattitude(){
      let validate = validator.validate([
        {
          fieldName: "Широта",
          value: this.company.lattitude.model,
          type: "integer"
        }
      ]);
      validate.result == "error"
        ? (this.company.lattitude.error = validate.message)
        : (this.company.lattitude.error = "");
      return validate;
    },
    vLongtitude(){
      let validate = validator.validate([
        {
          fieldName: "Долгота",
          value: this.company.longtitude.model,
          type: "integer"
        }
      ]);
      validate.result == "error"
        ? (this.company.longtitude.error = validate.message)
        : (this.company.longtitude.error = "");
      return validate;
    },
    vAddress() {
      let validate = validator.validate([
        {
          fieldName: "Адрес",
          value: this.company.address.model,
          type: "required",
          length: 255
        }
      ]);
      validate.result == "error"
        ? (this.company.address.error = validate.message)
        : (this.company.address.error = "");
      return validate;
    },
    vNumber() {
      this.requestValidateNumber++;
      let validate = validator.validate([
        {
          fieldName: "Номер",
          value: this.company.number.model,
          type: "required",
          length: 20
        },
        {
          fieldName: "Номер",
          value: this.company.number.model,
          type: "mask",
          mask: this.phoneMask
        }
      ]);
      validate.result == "error"
        ? (this.company.number.error = validate.message)
        : (this.company.number.error = "");
      return validate;
    },
    vClosedDescription() {
      let validate = validator.validate([
        {
          fieldName: "Описание причины закрытия",
          value: this.company.closed_description.model,
          type: "string",
          length: 255
        }
      ]);
      validate.result == "error"
          ? (this.company.closed_description.error = validate.message)
          : (this.company.closed_description.error = "");
      return validate;
    },
    vOkMessage() {
      let validate = validator.validate([
        {
          fieldName: "Сообщение для клиента",
          value: this.company.ok_message.model,
          type: "required",
          length: 1000
        }
      ]);
      validate.result == "error"
        ? (this.company.ok_message.error = validate.message)
        : (this.company.ok_message.error = "");
      return validate;
    },
    deleteAvatar() {
      this.deletePopup.show = true;
    },

    changePhoto(file) {
      this.$emit('changePhoto', file);
    },

    closeDeletePopup() {
      this.deletePopup.show = false;
    },
    updateCompany() {
      if (this.validateData) {
        return false;
      }
      this.$store.dispatch("startPreloader");
      userRepository.updateCompany({
        id: this.data.company.id,
        name: this.company.name.model,
        city: this.company.city.model,
        lattitude: this.company.lattitude.model,
        longtitude: this.company.longtitude.model,
        address: this.company.address.model,
        number: this.company.number.model,
        ok_message: this.company.ok_message.model,
        logo: this.croppieData.imageBase,
        company_status: this.company.company_status.model,
        closed_description: this.company.closed_description.model
      }).then(resp => {
        if (resp.data.result === "ok") {
          this.$emit("updateCompany");
        }
        this.$store.dispatch("addNotification", {
          text: "Данные успешно изменены",
          time: 4,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  }
};
</script>

<style scoped lang="less">
.edit-company--avatar {
  text-align: center;

  img {
    width: 130px;
  }
}
</style>
